{
  "breadcrumbs": {
    "index": "Common Services",
    "clientSpaces": {
      "index": "Client Spaces",
      "create": "Create Client Space",
      "dashboard": "$t(clientAccess:breadcrumbs.organization.dashboard)"
    },
    "currencies": {
      "create": "Create Currency",
      "edit": "Edit Currency",
      "add": "Add New Currency"
    }
  },
  "components": {
    "valueDescriptionsModal": {
      "products": {
        "ads": "Alias Directory Service: Enables card/account alias lookup and directory services, typically used for payment alias resolution (e.g. proxy identifiers to PAN)",
        "apata": "Grants access to the Apata 3D Secure authentication provider integration for clients using Apata as their 3DS vendor",
        "cardlimits": "Allows viewing and management of card-level spend/velocity limits (e.g. daily, per-transaction, ATM limits)",
        "digitalwallets": "Grants visibility into digital wallet tokenisation and provisioning details (Apple Pay, Google Pay, etc)",
        "eds": "Provides access to Event Delivery Service (webhooks)",
        "issuer": "Core issuer-side product access, covering standard card issuing functionality for the client",
        "programme-manager": "Unlocks programme management tooling for clients managing multi-issuer or multi-programme card portfolios",
        "rdx": "Grants access to the  3D Secure (RDX) authentication provider integration as an alternative to Apata",
        "scamdetect": "Enables fraud/scam detection features for flagging suspicious transaction patterns",
        "showencrypted": "Grants permission to view encrypted/sensitive data fields in their raw encrypted form",
        "showpan": "Grants permission to view the full, unmasked Primary Account Number (PAN)",
        "universal": "A catch-all entitlement granting broad/default product access, typically used where no specific product restriction applies",
        "ws": "Web Services: Enables access to general web services/API endpoints for the client integration"
      },
      "scopes": {
        "3ds.read": "Enables you to use the Get 3DS Configuration endpoint",
        "ads.read": "Enables you to use the GET endpoints for Visa Alias Directory",
        "ads.write": "Enables you to use the POST, DELETE and PUT endpoints for Visa Alias Directory",
        "adxapi": "Enables you to use endpoints for the ADX (Cardinal) 3D Secure provider integration",
        "apata.read": "Enables you to use GET endpoints to retrieve Apata 3D Secure configuration/authentication data",
        "apata.write": "Enables you to use POST/PATCH endpoints to create or update Apata 3D Secure configuration",
        "bulkcard.read": "Enables you to use the Get Bulk Card Progress endpoint",
        "bulkcard.write": "Enables you to use the Create Bulk Card endpoint",
        "cards.encrypted": "Enables you to use the Get Encrypted Data endpoint",
        "cards.read": "Enables you to use GET endpoints to return information on cards",
        "cards.sensitive": "Enables you to use the Get Full PAN endpoint",
        "cards.write": "Enables you to use the POST, UPDATE and PATCH endpoints to create and update card information",
        "credit.read": "Enables you to use GET endpoints for credit related account or product data",
        "credit.write": "Enables you to use POST/PATCH endpoints for credit-related account or product operations",
        "cts.read": "Enables you to use GET endpoints for Card Transaction Services (CTS) data",
        "cts.write": "Enables you to use POST endpoints for Card Transaction Services (CTS) operations",
        "cvv.read": "Enables you to use the Retrieve CVV endpoint",
        "cvv.write": "Enables you to use the Unblock CVV endpoint",
        "issuer.write": "Enables you to use POST endpoints for issuer-level configuration or operations",
        "limits.read": "Enables you to use GET endpoints to retrieve card/account limit details (e.g. spend, velocity limits)",
        "limits.write": "Enables you to use POST endpoints to set or update card/account limits",
        "pin.read": "Enables you to use the Retrieve PIN endpoint",
        "pin.write": "Enables you to use the Set PIN and Unblock PIN endpoint",
        "rdxapi": "Enables you to use endpoints for the RDX 3D Secure provider integration (alternative to Apata)",
        "scamdetect": "Enables you to use endpoints related to scam/fraud detection features (e.g. flagging suspicious transactions)",
        "ws": "Enables access to general web services endpoints (EDS)"
      }
    },
    "trustStoreJwks": {
      "jwks": "JSON Web Key Set (JWKS)"
    },
    "trustStore": {
      "title": "Authentication Certificate",
      "certificate": "Certificate",
      "validFrom": "Valid From",
      "validTo": "Valid to",
      "daysLeft": "Days left",
      "downloadCertificate": "Download Certificate",
      "expiry": {
        "columnHeader": "Expiry",
        "expired": "Expired {{count}} day ago",
        "expired_other": "Expired {{count}} days ago",
        "critical": "Expires in {{count}} day",
        "critical_other": "Expires in {{count}} days",
        "warning": "Expiring in {{count}} day",
        "warning_other": "Expiring in {{count}} days",
        "valid": "Valid for {{count}} day",
        "valid_other": "Valid for {{count}} days"
      }
    },
    "clientSpaces": {
      "createNew": "Create New Client Space",
      "search": "Search client spaces..."
    },
    "dashboard": {
      "metrics": {
        "total": "Total Client Spaces",
        "activeSpaces": "Active Spaces",
        "provisioning": "Provisioning",
        "failedProvisions": "Failed Provisions"
      },
      "charts": {
        "regionalDistribution": {
          "title": "Regional Distribution",
          "subtitle": "Client spaces distributed across AWS regions"
        },
        "statusDistribution": {
          "title": "Status Distribution",
          "subtitle": "Current status breakdown of all client spaces"
        },
        "types": {
          "pie": "Pie",
          "donut": "Donut",
          "bar": "Bar"
        },
        "clickToFilter": "Click to filter main list"
      },
      "usageTable": {
        "title": "Resource Usage Breakdown",
        "totalReadUnits": "Total Read Units",
        "totalWriteUnits": "Total Write Units",
        "totalStorage": "Total Storage",
        "totalCost": "Total Monthly Cost",
        "columns": {
          "clientSpace": "Client Space",
          "storage": "Storage",
          "estimatedCost": "Est. Monthly Cost",
          "lastUpdated": "Last Updated"
        }
      }
    },
    "details": {
      "tabs": {
        "configuration": "$t(common:labels.configuration)",
        "logs": "Logs",
        "resources": "Resources"
      }
    },
    "organizationDashboard": {
      "title": "Organisation Dashboard - {{name}}",
      "error": "Failed to load organisation data. Please try again.",
      "stats": {
        "activeUsers": "Active Users",
        "oauthClients": "$t(clientAccess:breadcrumbs.oauthClients.index)"
      },
      "quickActions": {
        "title": "$t(commonServices:components.userDashboard.quickActions.title)",
        "addNewUsers": "Add New Users",
        "inviteUsers": "Invite Users",
        "reviewApplications": "Review Applications",
        "userManagement": "$t(common:components.mainMenu.userManagement)"
      },
      "messages": {
        "featureComingSoon": "Feature coming soon!"
      }
    },
    "adminOrganizationWrapper": {
      "adminBanner": "Admin View - You are viewing this organisation as an administrator",
      "loadingOrganization": "Loading organisation...",
      "organizations": "Organisations",
      "unknownOrganization": "Unknown Organisation",
      "backToOrganizations": "Back to Organisations",
      "adminAccess": "Admin Access",
      "invalidOrganization": "Invalid Organisation",
      "noOrganizationId": "No organisation ID provided in the URL."
    },
    "userDashboard": {
      "quickActions": {
        "title": "Related Actions"
      }
    },
    "ssoDetails": {
      "sso": "SSO",
      "addProvider": "Add SSO Provider",
      "confirmDeleteTitle": "Delete SSO provider",
      "confirmDelete": "Are you sure you want to delete this SSO provider?",
      "confirmDeleteAlert": "Deleting this SSO provider will revoke access for all users",
      "deleteError": "Failed to delete SSO configuration.",
      "deleteSuccess": "This SSO provider has been permanently deleted.",
      "error": "Failed to load SSO configurations.",
      "actions": {
        "runHealthCheck": "Run Health Check"
      },
      "xmlMetadata": "XML Metadata",
      "configurationProperties": {
        "provider": "$t(commonServices:referenceData.labels.providerId)",
        "healthcheck": "$t(commonServices:components.ssoConfigurationWizard.steps.healthCheck)",
        "status": "$t(common:labels.status)",
        "metadata": "Metadata",
        "issuer": "$t(commonServices:components.ssoConfigurationWizard.providerSpecificFields.oidc.issuer.label)",
        "clientId": "$t(common:labels.clientId)",
        "clientSecret": "$t(commonServices:oauthLabels.clientSecret)",
        "authEndpoint": "Authentication Endpoint",
        "discoveryUrl": "Discovery Url",
        "tokenEndpoint": "$t(commonServices:components.ssoConfigurationWizard.providerSpecificFields.oidc.tokenEndpoint.label)",
        "userInfoEndpoint": "$t(commonServices:components.ssoConfigurationWizard.providerSpecificFields.oidc.userInfoEndpoint.label)",
        "ssoUrl": "Sso Url"
      }
    },
    "ssoIdentityProviders": {
      "messages": {
        "created": "Identity Provider Created",
        "createdDescription": "SSO configuration has been created successfully.",
        "creationFailed": "Creation Failed",
        "creationFailedDescription": "Failed to create identity provider.",
        "updated": "Identity Provider Updated",
        "updatedDescription": "SSO configuration has been updated successfully.",
        "deleted": "Identity Provider Deleted",
        "deletedDescription": "SSO configuration has been removed successfully.",
        "deletionFailed": "Deletion Failed",
        "healthCheckDone": "Health Check Completed",
        "healthCheckStatus": "Status: {{status}}",
        "healthCheckFailed": "Health Check Failed"
      }
    },
    "ssoConfigurationWizard": {
      "steps": {
        "identityProvider": "Identity Provider",
        "healthCheck": "Health Check"
      },
      "actions": {
        "save": "Save Configuration",
        "viewConfigurations": "View Configurations"
      },
      "messages": {
        "saveFailed": "Failed to Save Configuration",
        "saveFailedDescription": "There was an error saving your SSO configuration. Please try again."
      },
      "healthCheckStep": {
        "title": "Identity Provider Health Check",
        "description": "Verifying connectivity and configuration of your identity provider.",
        "running": "Running health check...",
        "lastChecked": "Last Checked",
        "errorsTitle": "Errors",
        "healthCheckStatus": "Health Check Status"
      },
      "subtitle": "Configure Single Sign-On for organization: {{organizationId}}",
      "identityProviderStep": {
        "title": "Identity Provider Preferences",
        "description": "Choose a provider and enter basic details for your SSO configuration.",
        "fields": {
          "name": {
            "label": "Identity Provider Name",
            "placeholder": "Enter a name for this provider",
            "required": "Please enter an identity provider name"
          },
          "description": {
            "placeholder": "Add a short description"
          },
          "providerType": {
            "required": "Please select a provider type"
          }
        }
      },
      "providerSpecificFields": {
        "shared": {
          "attributeMapping": "Attribute Mapping"
        },
        "saml": {
          "title": "SAML Configuration",
          "entityId": {
            "placeholder": "https://idp.example.com/metadata",
            "help": "The unique identifier for your Identity Provider."
          },
          "metadataSource": {
            "label": "Metadata Source"
          },
          "metadataUrl": {
            "label": "Metadata URL",
            "required": "Please enter a metadata URL",
            "help": "The URL of your Identity Provider metadata."
          },
          "metadataXml": {
            "label": "Metadata XML",
            "required": "Please enter a metadata XML",
            "placeholder": "Paste SAML metadata XML"
          },
          "ssoUrl": {
            "label": "Single Sign-On (SSO) URL",
            "placeholder": "https://idp.example.com/sso",
            "required": "Please enter an SSO URL"
          },
          "acsUrl": {
            "label": "Assertion Consumer Service (ACS) URL",
            "placeholder": "https://app.example.com/sso/acs",
            "required": "Please enter an ACS URL",
            "help": "The URL where SAML assertions should be sent."
          },
          "encryptAssertions": "Encrypt SAML assertions",
          "x509Certificate": {
            "label": "X.509 Certificate",
            "placeholder": "Paste the certificate",
            "help": "Used to validate the signature on SAML responses."
          }
        },
        "oidc": {
          "title": "OIDC Configuration",
          "discoveryUrl": {
            "label": "Discovery URL",
            "placeholder": "https://idp.example.com/.well-known/openid-configuration",
            "required": "Please enter a discovery URL",
            "help": "The OIDC discovery document URL for your provider."
          },
          "issuer": {
            "label": "Issuer",
            "placeholder": "Enter an issuer",
            "required": "Please enter an issuer",
            "help": "The issuer identifier for your OIDC provider."
          },
          "clientId": {
            "placeholder": "Enter your client ID",
            "required": "Please enter a client ID"
          },
          "clientSecret": {
            "placeholder": "Enter your client secret",
            "required": "Please enter a client secret"
          },
          "authorizationEndpoint": {
            "label": "Authorization Endpoint",
            "placeholder": "https://idp.example.com/oauth2/authorize",
            "required": "Please enter an authorization endpoint"
          },
          "tokenEndpoint": {
            "label": "Token Endpoint",
            "placeholder": "https://idp.example.com/oauth2/token",
            "required": "Please enter a token endpoint"
          },
          "userInfoEndpoint": {
            "label": "User Info Endpoint",
            "placeholder": "https://idp.example.com/oauth2/userinfo",
            "required": "Please enter a user info endpoint"
          },
          "jwksUri": {
            "label": "JWKS URI",
            "placeholder": "https://idp.example.com/.well-known/jwks.json",
            "help": "JSON Web Key Set endpoint for signature validation."
          },
          "scopes": {
            "placeholder": "openid, profile, email",
            "help": "Comma-separated list of scopes to request."
          },
          "responseType": {
            "label": "Response Type"
          },
          "responseMode": {
            "label": "Response Mode"
          }
        }
      },
      "reviewStep": {
        "alertTitle": "Review SSO Configuration",
        "alertDescription": "Please review your SSO configuration before submitting.",
        "identityProviderTitle": "Identity Provider Configuration",
        "providerType": "Provider Type",
        "entityId": "Entity ID",
        "yourDetailsSectionTitle": "Your Details"
      },
      "attributeMappings": {
        "title": "Attribute mappings",
        "addMapping": "Add Attribute Mapping",
        "internalAttribute": {
          "label": "Internal Attribute",
          "placeholder": "Select an internal attribute"
        },
        "externalAttribute": {
          "label": "External Attribute",
          "placeholder": "e.g. email"
        },
        "required": {
          "label": "Attribute is required"
        }
      }
    },
    "userDirectory": {
      "allUsers": "All Users",
      "exportUserList": "Export User List",
      "searchPlaceholder": "Search users",
      "viewProfile": "View Profile",
      "tabs": {
        "users": "$t(common:labels.users)",
        "ssoDetails": "SSO Details"
      },
      "remove": {
        "removeUser": "Remove User",
        "removeUserConfirmation": "Are you sure you want to remove this user from the organization? This action cannot be undone."
      },
      "actions": {
        "resendInvite": "Re-send invite"
      },
      "statusModal": {
        "deactivate": {
          "title": "Deactivate User",
          "description": "Are you sure you want to deactivate this user:",
          "alert": "Deactivating this user will remove their access."
        },
        "activate": {
          "title": "Activate User",
          "description": "Are you sure you want to activate this user:",
          "alert": "When you activate this user, an email will be sent so they can access the portal."
        },
        "resendInvite": {
          "title": "Re-send Invite",
          "description": "The invitation to {{name}} will be re-sent."
        }
      },
      "rolesInfoModal": {
        "title": "Roles",
        "description": "These are predefined roles based on recommended access patterns. You can create your own roles, while adding new users.",
        "userManagementInfo": "User management is restricted to Super Admins. If you’re seeing this page, you currently have Super Admin access. To assign or update this role, please contact our <customerServiceLink>customer service</customerServiceLink>.",
        "roles": {
          "superAdmin": {
            "name": "Super Admin",
            "description": "Full platform control, including configurations, all operational settings and the ability to add and manage users."
          },
          "admin": {
            "description": "Full platform control, including configurations, and all operational settings, without permission to add or manage users."
          },
          "sensitiveInformationManager": {
            "description": "Restricted access to sensitive card data, including PAN-finder operations."
          }
        }
      }
    }
  },
  "fields": {
    "accountEmail": "Account Email",
    "awsAccountId": "AWS Account ID",
    "awsRegion": "AWS Region",
    "writeRegion": "Write Region",
    "pmId": "PM ID",
    "issuerId": "Issuer ID",
    "internalId": "Internal ID",
    "whaleAccount": "Whale Account",
    "deploymentStatus": "Deployment Status",
    "provisionedProductId": "Provisioned Product ID",
    "storageCost": "Storage Cost",
    "otherServicesCost": "Other Services Cost",
    "monthlyCost": "Monthly Cost",
    "storageUsed": "Storage Used",
    "readUnits": "Read Units",
    "writeUnits": "Write Units",
    "dynamoDbReadCost": "DynamoDB Read Cost",
    "dynamoDbWriteCost": "DynamoDB Write Cost"
  },
  "labels": {
    "costBreakdown": "Cost Breakdown",
    "resourceOverview": "Resource Overview",
    "awsConfiguration": "AWS Configuration",
    "clientSpaceDetails": "Client Space Details",
    "accountInformation": "Account Information",
    "readOnlyInformation": "Read-Only Information",
    "metaInformation": "Meta Information",
    "auditInformation": "Audit Information",
    "created": "Created",
    "never": "Never",
    "suspend": "Suspend",
    "claimId": "Claim Id"
  },
  "messages": {
    "createSuccess": "Client Space created successfully",
    "createError": "Failed to create Client Space",
    "updateSuccess": "Client Space updated successfully",
    "updateError": "Failed to update Client Space",
    "deleteSuccess": "Client Space deleted successfully",
    "deleteError": "Failed to delete Client Space",
    "confirmDelete": "Are you sure you want to delete Client Space '{{id}}'? This action cannot be undone.",
    "clientSpaceNotFound": "The requested client space could not be found.",
    "noResourceData": "No resource data available",
    "resourceDataDescription": "No resource data available for this client space"
  },
  "validation": {
    "checkFormErrors": "Please check the form for errors before submitting",
    "accountNameMin": "Account name must be at least 3 characters",
    "accountNameMax": "Account name cannot exceed 100 characters"
  },
  "tooltips": {
    "whaleAccount": "Indicates if this is a high-value enterprise account"
  },
  "placeholders": {
    "accountName": "Enter account name",
    "accountEmail": "Enter account email",
    "selectStatus": "Select account status",
    "searchLogs": "Search logs..."
  },
  "descriptions": {
    "configurationTab": "View and manage the configuration settings for this client space"
  },
  "common": {
    "days": "days",
    "organization": "organisation",
    "permissions": "permissions",
    "org": "org",
    "selectGroups": "Choose groups to assign to this user",
    "noGroupsAvailable": "No groups available",
    "noGroupsAvailableDescription": "There are no groups available for assignment. Please contact your administrator to create groups first.",
    "selectAtLeastOneGroup": "Please select at least one group for this user",
    "selectedGroups": "Selected Groups:",
    "noGroupsSelected": "No Groups Selected",
    "selectGroupsMessage": "Please select at least one group to assign permissions to this user. Users receive permissions through group membership.",
    "accountStatus": "Account Status",
    "accountSetup": "Account Setup",
    "sendWelcomeEmail": "Send welcome email with account details",
    "requirePasswordReset": "Require password reset on first login",
    "failedToLoadGroups": "Failed to load groups"
  },
  "oauthLabels": {
    "reviewConfiguration": "Review Your Configuration",
    "clientEnvironment": "Client Environment",
    "securityConfiguration": "Security Configuration",
    "grantTypes": "Grant Types",
    "pkce": "PKCE (Proof Key for Code Exchange)",
    "recommendedConfiguration": "Recommended Configuration",
    "pkceRequired": "Required (Recommended)",
    "noDescription": "No description",
    "accessToken": "Access Token",
    "refreshToken": "Refresh Token",
    "idToken": "ID Token",
    "hours": "hour(s)",
    "days": "day(s)",
    "viewDetails": "View Details",
    "clientSecret": "Client Secret"
  },
  "oauthHelp": {
    "clientName": "A descriptive name for your OAuth client",
    "description": "Brief description of this application",
    "scopes": "Select the permissions your application needs",
    "allowedScopes": "Choose specific scopes from those available in your organization. If none selected, all available scopes will be granted.",
    "tokenLifetimes": "Configure how long tokens remain valid. Shorter lifetimes are more secure but may require more frequent re-authentication.",
    "accessTokenLifetime": "How long access tokens remain valid (in seconds)",
    "refreshTokenLifetime": "How long refresh tokens remain valid (in seconds)",
    "idTokenLifetime": "How long ID tokens remain valid (in seconds)",
    "reviewConfiguration": "Please review the settings below before creating your OAuth client."
  },
  "oauthPlaceholders": {
    "clientName": "My Application",
    "description": "A mobile application for accessing user data...",
    "scopes": "Select scopes",
    "allowedScopes": "Select specific scopes (optional)"
  },
  "oauthValidation": {
    "clientNameRequired": "Please enter a client name",
    "descriptionRequired": "Please enter a description",
    "clientNameMinLength": "Client name must be at least 3 characters",
    "clientEnvironmentRequired": "Please select a client environment"
  },
  "oauthEnvironments": {
    "public": {
      "title": "Public",
      "description": "Cannot securely store secrets (mobile apps, SPAs)"
    },
    "confidential": {
      "title": "Confidential",
      "description": "Can securely store secrets (server-side apps)"
    }
  },
  "oauthMessages": {
    "clientCreatedSuccess": "OAuth client created successfully!",
    "clientCreationFailedTitle": "Failed to create OAuth client",
    "clientCreationFailedDescription": "Something went wrong while creating the client. Please try again.",
    "deleteOAuthClient": "Delete OAuth Client",
    "sureWantDeleteOAuthClient": "Are you sure you want to delete this OAuth client? This action cannot be undone.",
    "clientDeletedSuccessfully": "Client deleted successfully",
    "failedClientDelete": "Failed to delete client",
    "clientConfiguration": "Client Configuration",
    "editConfiguration": "Edit Configuration",
    "configurationUpdatedSuccessfully": "Configuration updated successfully",
    "failedToUpdateConfiguration": "Failed to update configuration",
    "clientNotFoundTitle": "Client Not Found",
    "clientNotFoundDescription": "The requested OAuth client could not be found.",
    "permissions": "Permissions",
    "accessInformation": "Access Information",
    "allScopesGranted": "All available organization scopes will be granted",
    "editScopes": "Edit Scopes",
    "scopesUpdatedSuccessfully": "Scopes updated successfully",
    "failedToUpdateScopes": "Failed to update scopes"
  },
  "userManagement": {
    "messages": {
      "userCreated": "User Created",
      "userCreationFailed": "User Creation Failed",
      "userUpdated": "User Updated",
      "userUpdateFailed": "User Update Failed",
      "failedToUpdateUser": "Failed to update user",
      "userCreatedSuccess": "'{{name}}' has been created successfully",
      "userUpdatedSuccess": "'{{name}}' has been updated successfully",
      "failedToLoadUsers": "Failed to load users",
      "failedToLoadData": "Failed to Load Data",
      "failedToLoadDataDescription": "There was an error loading user management data.",
      "invitationSentSuccess": "User invitation sent successfully",
      "invitationSentDescription": "Invitation sent to {{email}}",
      "invitationFailed": "Invitation Failed",
      "failedToSendInvitation": "Failed to send invitation",
      "bulkInvitationSent": "Bulk Invitation Sent",
      "bulkInvitationSentDescription": "Successfully sent {{count}} invitations",
      "bulkInvitationFailed": "Bulk Invitation Failed",
      "failedToSendBulkInvitations": "Failed to send bulk invitations",
      "userDeactivated": "User Deactivated",
      "userDeactivatedDescription": "User has been successfully deactivated",
      "userActivated": "User Activated",
      "userActivatedDescription": "User has been successfully activated. An email with portal access instructions has been sent.",
      "userRemoved": "User Removed",
      "userRemovedDescription": "User has been removed from the organization",
      "removalFailed": "Removal Failed",
      "failedToRemoveUser": "Failed to remove user",
      "emailSent": "Invite Re-sent",
      "emailSentDescription": "Success! The portal invite has been re-sent to the user.",
      "sendingEmailFailed": "Sending Failed",
      "sendingEmailFailedDescription": "Sending welcome email failed",
      "bulkOperationComplete": "Bulk Operation Complete",
      "bulkOperationCompleteDescription": "Successfully updated {{count}} users",
      "bulkOperationFailed": "Bulk Operation Failed",
      "failedToCompleteBulkOperation": "Failed to complete bulk operation"
    },
    "addNewUsers": {
      "step1": "New user setup",
      "addNewUsers": "Add new users",
      "step2": "Review and finish",
      "fetchRolesFailed": "Failed to load available roles."
    },
    "editUser": {
      "step1": "Edit user"
    },
    "labels": {
      "userId": "User ID",
      "roles": "Role(s)",
      "organization": "Organization",
      "organizationId": "Organization ID",
      "invitationSent": "Invitation Sent",
      "editContactInformation": "Edit contact information",
      "exportUsersList": "Export Users List",
      "noThreddRolesSelected": "No Thredd roles selected"
    },
    "placeholders": {
      "email": "user@example.com",
      "phone": "+1 (555) 123-4567",
      "jobTitle": "Software Engineer",
      "selectDepartment": "Select department"
    },
    "validation": {
      "emailRequired": "Email is required",
      "validEmailRequired": "Valid email address is required",
      "groupRequired": "Group assignment required",
      "selectOneGroup": "Please select at least one group for the user",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required"
    },
    "departments": {
      "engineering": "Engineering",
      "sales": "Sales",
      "marketing": "Marketing",
      "hr": "Human Resources",
      "operations": "Operations"
    },
    "components": {
      "createOAuthClient": {
        "title": "Create OAuth Client"
      },
      "addNewUsers": {
        "description": "Invite new users to join your organisation and manage their access.",
        "roleLabel": "Role",
        "addAnotherUser": "Add Another User",
        "restrictedPmCodesLabel": "Restricted PM Codes"
      },
      "editUser": {
        "description": "Update this user's details and manage their access."
      },
      "roleGroup": {
        "admin": {
          "label": "Admin Roles",
          "roles": {
            "manager": {
              "label": "Manager",
              "description": "General oversight and management access across the platform, covering day-to-day operational activity."
            },
            "sales": {
              "label": "$t(commonServices:userManagement.departments.sales)",
              "description": "Access scoped to sales-related activity, such as prospect and client account visibility."
            },
            "internal": {
              "label": "$t(common:labels.internal)",
              "description": "Internal-use role for Thredd staff, scoped to internal administrative functions."
            },
            "organisationAdmin": {
              "label": "Organisation Admin",
              "description": "Full platform control, including configurations and all operational settings. Includes the ability to change SSO configuration and manage user roles."
            },
            "organisationManager": {
              "label": "Organisation Manager",
              "description": "Manages organisation-level settings and users, without the ability to change SSO configuration."
            },
            "sensitiveInformationManager": {
              "label": "Sensitive Information Manager",
              "description": "Access to sensitive card data, including PAN. Finds violations."
            }
          }
        },
        "sponsorGuard": {
          "label": "SponsorGuard Roles",
          "roles": {
            "sponsorGuardRead": {
              "label": "SponsorGuard View",
              "description": "Grants view-only access to SponsorGuard. View dashboards, statuses and configurations."
            },
            "sponsorGuardWrite": {
              "label": "SponsorGuard Configure",
              "description": "Grants ability to configure SponsorGuard, including setting monitoring rules and thresholds."
            },
            "sponsorGuardApproval": {
              "label": "SponsorGuard Approvals",
              "description": "Grants ability to approve or reject requests to freeze or unfreeze a Programme Manager or Product."
            },
            "sponsorGuardFreeze": {
              "label": "SponsorGuard Freeze",
              "description": "Grants the ability to request to freeze or unfreeze a Programme Manager or Produc in SponsorGuard, stopping or resuming transaction processing."
            }
          }
        },
        "moneyMovement": {
          "label": "Money Movement Roles",
          "roles": {
            "achRead": {
              "label": "ACH Read",
              "description": "Access to Money Movement screen allowing ACH transaction to be search if troubleshooting is required"
            }
          }
        },
        "agenticAssistant": {
          "label": "Agentic Assistant",
          "roles": {
            "agenticRead": {
              "label": "Agentic Read",
              "description": "Access to the Agentic Assistant chatbot allowing card, transaction, and account data to be queried in a read-only mode for troubleshooting internal and external queries."
            },
            "agenticWrite": {
              "label": "Agentic Write",
              "description": "Access to the Agentic Assistant chatbot allowing supervised write actions (e.g. card status, control, and limit changes) to be proposed and approved via the chatbot interface, in addition to read access."
            }
          }
        },
        "developer": {
          "label": "Developer Roles",
          "roles": {
            "developer": {
              "label": "Developer",
              "description": "Configures and manages webhooks for system integrations."
            }
          }
        },
        "cardsAndTransactions": {
          "label": "Cards & Transactions Roles",
          "roles": {
            "cardOperationsSpecialist": {
              "label": "Cards Operations Specialist",
              "description": "Card lifecycle management and transaction visibility."
            },
            "cardConfigurationManager": {
              "label": "Card Config Manager",
              "description": "Manages card configurations."
            },
            "cardBalanceManager": {
              "label": "Card Balance Manager",
              "description": "Manages balance adjustments and balance transfers."
            },
            "chargebackManager": {
              "label": "Chargeback Manager",
              "description": "Manages chargeback cases and dispute resolution workflows."
            },
            "creditManager": {
              "label": "Credit Manager",
              "description": "Manages credit limits, credit line adjustments, and related credit operations."
            }
          }
        },
        "stablecoin": {
          "label": "Stablecoin",
          "roles": {
            "stablecoinAdmin": {
              "label": "Stablecoin Admin",
              "description": "Full access to the stablecoin area, including wallets, balances, beneficiaries, payments and configuration settings."
            }
          }
        },
        "readOnly": {
          "label": "Read-Only Roles",
          "roles": {
            "readOnly": {
              "label": "Read-Only",
              "description": "View-only access to cards and transactions information."
            }
          }
        }
      }
    },
    "organisationRegistrationWizard": {
      "validation": {
        "identityProviderTypeRequired": "Identity provider type is required",
        "samlEntityIdRequired": "SAML Entity ID is required",
        "samlMetadataUrlRequired": "SAML metadata URL is required",
        "samlMetadataUrlInvalid": "SAML metadata URL must be valid",
        "samlSsoUrlInvalid": "SAML SSO URL must be valid",
        "oidcIssuerRequired": "OIDC issuer is required",
        "oidcClientIdRequired": "OIDC client ID is required",
        "oidcClientSecretRequired": "OIDC client secret is required",
        "passwordMinLength": "Minimum password length must be at least 6",
        "passwordReuseCount": "Reuse count must be at least 1 when prevent reuse is enabled",
        "mfaMethodRequired": "At least one MFA method must be enabled",
        "sessionIdleTimeout": "Idle timeout must be less than session timeout",
        "termsAccepted": "You must accept the Terms of Service",
        "dataAccuracyConfirmed": "You must confirm the information is accurate",
        "contactAuthorized": "You must authorize Thredd to contact you",
        "awsResourcesAcknowledged": "You must acknowledge AWS resource creation"
      }
    },
    "alerts": {
      "pendingInvitationsTitle": "{{count}} pending invitations",
      "pendingInvitationsDescription": "Some users have not yet accepted their invitations",
      "resendInvitations": "Resend Invitations"
    }
  },
  "organizationManagement": {
    "details": {
      "notFound": "Organisation not found",
      "notFoundDescription": "No organisation found with ID: {{id}}",
      "tabs": {
        "security": "Security"
      },
      "actions": {
        "viewDashboard": "View Dashboard",
        "edit": "$t(common:labels.edit)",
        "reactivate": "Reactivate",
        "delete": "$t(common:components.buttons.delete)"
      },
      "security": {
        "title": "Security Policies",
        "passwordPolicy": "Password Policy",
        "mfaRequirements": "MFA Requirements",
        "sessionManagement": "Session Management",
        "accountSecurity": "Account Security",
        "minimumCharacters": "Minimum {{count}} characters",
        "require": "Require",
        "expiration": "Expiration",
        "preventReuseLast": "Prevent reuse of last {{count}} passwords",
        "requiredFor": "Required for",
        "methods": "Methods",
        "sessionTimeout": "Session timeout",
        "idleTimeout": "Idle timeout",
        "maxConcurrentSessions": "Max concurrent sessions",
        "rememberDevice": "Remember device",
        "lockout": "Lockout",
        "failedAttempts": "failed attempts",
        "lockoutDuration": "Lockout duration",
        "minutes": "minutes",
        "hours": "hours",
        "emailNotifications": "Email notifications",
        "emailVerification": "Email verification",
        "monitorSuspiciousActivity": "Monitor suspicious activity",
        "enabled": "$t(common:labels.enabled)",
        "disabled": "$t(common:labels.disabled)",
        "optional": "$t(common:labels.optional)",
        "yes": "$t(common:labels.yes)",
        "no": "$t(common:labels.no)",
        "passwordRequirements": {
          "uppercase": "Upper case",
          "lowercase": "Lower case",
          "numbers": "Numbers",
          "symbols": "Symbols"
        }
      },
      "confirmations": {
        "deleteTitle": "Delete Organisation",
        "deleteDescription": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
        "deleteConfirm": "$t(common:components.buttons.delete)",
        "cancel": "$t(common:components.buttons.cancel)"
      },
      "notifications": {
        "loadFailed": "Failed to Load Organisation",
        "loadFailedDescription": "Unable to load organisation details. Please try again.",
        "suspendFailed": "Failed to Suspend Organisation",
        "suspendFailedDescription": "Unable to suspend the organisation. Please try again.",
        "reactivateFailed": "Failed to Reactivate Organisation",
        "reactivateFailedDescription": "Unable to reactivate the organisation. Please try again.",
        "deleteFailed": "Failed to Delete Organisation",
        "deleteFailedDescription": "Unable to delete the organisation. Please try again."
      },
      "overview": {
        "title": "Organisation Overview",
        "organizationId": "Organisation ID",
        "pmCode": "PM Code",
        "emailDomains": "Email Domains",
        "createdBy": "$t(common:labels.createdBy)",
        "lastActivity": "Last Activity",
        "accountDetails": "$t(customerAccount:breadcrumbs.customers.accounts.detail)",
        "userPool": "User Pool",
        "clientId": "$t(common:labels.clientId)",
        "noDomainsConfigured": "No domains configured",
        "noProductsAssigned": "No products assigned"
      }
    },
    "settings": {
      "basicInfo": {
        "organizationName": "Organization Name",
        "organizationNameRequired": "Organization name is required",
        "organizationNamePlaceholder": "Enter organization name",
        "organizationInformation": "Organization Information",
        "importantNote": "Important Note",
        "organizationIdWarning": "The Organization ID cannot be changed after creation. Please ensure it is correct before submitting.",
        "reviewOrganizationDetails": "Review Organization Details",
        "reviewDescription": "Please review all the information before submitting your organization registration.",
        "slug": "Slug",
        "slugRequired": "Slug is required",
        "slugPlaceholder": "organisation-slug",
        "emailDomains": "$t(commonServices:organizationManagement.details.overview.emailDomains)",
        "emailDomainsPlaceholder": "Add email domains (e.g., example.com)",
        "pmInformation": "PM Information",
        "pmId": "PMID",
        "pmIdPlaceholder": "Enter PMID",
        "issuerIdPlaceholder": "Enter Issuer ID",
        "internalIdPlaceholder": "Enter Internal ID",
        "pmCodePlaceholder": "Enter PM code",
        "addPmCodePmId": "Add PM Code/PMID",
        "nopmInformation": "No PM information available",
        "products": "$t(common:components.mainMenu.products)",
        "productsPlaceholder": "Add products",
        "connection": "Connection",
        "connectionType": "Connection Type",
        "tls": "TLS",
        "mtls": "MTLS",
        "connectionDescription": "TLS – standard encrypted transport. MTLS – mutual TLS requiring client certificates.",
        "selectConnectionType": "Please select a connection type",
        "keepConnectionType": "Keep existing connection type",
        "clientSecretBasic": "Client Secret Basic",
        "selectClientAuthMethod": "Please select a client auth method",
        "authProvider": "Auth Provider",
        "authProviderDescription": "Cognito – managed by AWS Cognito. CloudEntity – managed by CloudEntity.",
        "cognito": "Cognito",
        "cloudentity": "CloudEntity",
        "selectAuthProvider": "Please select an auth provider",
        "keepAuthProvider": "Keep existing auth provider",
        "subClientIdPlaceholder": "Enter Sub Client ID"
      },
      "messages": {
        "settingsSaved": "Settings saved successfully",
        "settingsFailed": "Failed to save settings",
        "statusUpdated": "Organisation status updated successfully",
        "statusUpdateFailed": "Failed to update organisation status",
        "deleted": "Organisation deleted successfully",
        "deleteFailed": "Failed to delete organisation"
      },
      "saveChanges": "$t(common:components.buttons.saveChanges)",
      "tabs": {
        "basic": "Basic Info",
        "status": "$t(common:labels.status)",
        "admin": "Admin User"
      },
      "options": {
        "characters": "{{count}} characters",
        "days": "{{count}} days",
        "hours": "{{count}} hours",
        "minutes": "{{count}} minutes",
        "session": "{{count}} session",
        "sessions": "{{count}} sessions",
        "attempts": "{{count}} attempts"
      },
      "status": {
        "dangerZone": "Danger Zone",
        "dangerZoneDescription": "Changes in this section can affect organisation access and functionality.",
        "management": "Organisation Status Management",
        "keepActive": "Keep Active",
        "suspend": "Suspend (temporarily disable access)",
        "reasonForChange": "Reason for change",
        "reasonPlaceholder": "Explain the reason for this status change...",
        "deleteOrganization": "$t(commonServices:organizationManagement.details.confirmations.deleteTitle)",
        "permanentAction": "Permanent Action",
        "deleteWarning": "Deleting an organisation is irreversible. All associated data, users, and configurations will be permanently removed.",
        "deleteConfirmTitle": "Delete Organisation?",
        "deleteConfirmDescription": "Are you sure you want to delete {{name}}? This action cannot be undone.",
        "cancel": "$t(common:components.buttons.cancel)",
        "suspendBeforeDelete": "Suspend the organisation before deleting it."
      }
    }
  },
  "organizationReview": {
    "certificates": {
      "csrCommand": {
        "selectCertificateType": "Select a certificate type first (Signing or Transport).",
        "waitingForApplicationId": "Waiting for application ID from URL...",
        "waitingForOrganisationId": "Waiting for organisation ID..."
      }
    },
    "applications": {
      "title": "$t(clientAccess:breadcrumbs.applications.index) ({{total}})",
      "subtitle": "Review and manage organisation registration applications",
      "addNewApplication": "Add Application",
      "stats": {
        "pendingReview": "Pending Review",
        "avgProcessing": "Avg. Processing"
      },
      "table": {
        "columns": {
          "name": "$t(common:labels.nameLabel)",
          "appId": "App ID",
          "description": "$t(common:labels.description)",
          "country": "$t(common:components.addressFields.country)",
          "adminContact": "Admin Contact",
          "priority": "$t(common:components.featureRequest.priorityLabel)",
          "submitted": "$t(commonServices:organizationReview.applications.statusLabels.submitted)"
        }
      },
      "actions": {
        "reviewApplication": "Review Application",
        "technicalConfiguration": "$t(clientAccess:breadcrumbs.applications.technicalConfiguration)",
        "editApplication": "Edit Application",
        "deleteApplication": "Delete Application"
      },
      "deleteConfirm": {
        "title": "Delete Application?",
        "description": "$t(commonServices:organizationManagement.settings.status.deleteConfirmDescription)"
      },
      "notifications": {
        "createSuccess": "Application Created",
        "createError": "Application Creation Failed",
        "createErrorFallback": "Failed to create application",
        "updateSuccess": "Application Updated",
        "updateSuccessDescription": "Application has been updated successfully",
        "updateError": "$t(clientLifecycle:errors.updateFailed)",
        "updateErrorFallback": "Failed to update application",
        "deleteSuccess": "Application Deleted",
        "deleteSuccessDescription": "Application has been deleted successfully",
        "deleteError": "Delete Failed",
        "deleteErrorFallback": "Failed to delete application",
        "listErrorFallback": "Failed to load applications"
      },
      "changeIndicators": {
        "thisMonth": "{{count}} this month",
        "awaiting": "{{count}} awaiting",
        "successRate": "{{rate}}% rate"
      },
      "statusLabels": {
        "submitted": "Submitted",
        "under_review": "$t(commonServices:organizationReview.applications.stats.pendingReview)",
        "technical_review": "Technical Review",
        "configuring": "Configuring",
        "awaiting_domain": "Awaiting Domain",
        "ready": "Ready",
        "active": "$t(common:status.active)",
        "rejected": "$t(common:status.rejected)",
        "expired": "Expired"
      },
      "loading": "Loading applications...",
      "error": "Failed to load applications data. Please try again."
    }
  },
  "organizationRegistration": {
    "tooltips": {
      "organizationName": "The display name of the organisation.",
      "organizationId": "The Org ID is the unique identifier for this organisation across the platform. It is generated from the organisation name and cannot be changed after creation.",
      "emailDomains": "Email domains owned by the organisation. Users must sign in with an email address on one of these domains.",
      "issuerId": "The numeric Issuer ID assigned to this organisation.",
      "subClientId": "The UUID of the sub-client created for this organisation as part of the BTP platform.",
      "authProvider": "The identity provider that manages authentication for this organisation.",
      "emailDomain": "The email domain used for the administrator account. Must be one of the domains entered for the organisation."
    },
    "organizationInfoStep": {
      "title": "Organisation Information",
      "labels": {
        "organizationName": "Organisation Name"
      },
      "placeholders": {
        "organizationName": "Enter your organisation name",
        "organizationId": "Enter a unique organisation ID",
        "emailDomains": "company.com, subsidiary.com"
      },
      "validation": {
        "organizationNameRequired": "Organisation name is required",
        "organizationIdRequired": "Organisation ID is required",
        "organizationIdPattern": "Organisation ID can only contain lowercase letters, numbers, and hyphens",
        "emailDomainsRequired": "At least one email domain is required",
        "invalidDomains": "Invalid domain format: {{domains}}"
      },
      "help": {
        "organizationId": "Cannot be modified after creation",
        "emailDomainsExample": "Enter one or more email domains separated by commas (e.g., company.com, subsidiary.com)"
      }
    },
    "organizationDetailsStep": {
      "fields": {
        "administratorAccount": "Administrator Account",
        "companyName": "$t(common:labels.companyName)",
        "companyWebsite": "Company Website",
        "companySize": "Company Size",
        "country": "$t(common:components.addressFields.country)",
        "briefDescription": "Brief Description",
        "adminEmail": "Admin Email",
        "firstName": "$t(common:labels.firstName)",
        "lastName": "$t(common:labels.lastName)"
      },
      "help": {
        "briefDescription": "Tell us what your organisation does (optional)"
      },
      "placeholders": {
        "companyName": "$t(clientAccess:placeholders.companyName)",
        "companyWebsite": "$t(clientAccess:placeholders.companyWebsite)",
        "companySize": "Select Size",
        "country": "Select Country",
        "description": "Describe your organisation's main activities...",
        "adminEmail": "$t(clientAccess:placeholders.adminEmail)",
        "firstName": "John",
        "lastName": "Smith",
        "phoneNumber": "+1234567890",
        "jobTitle": "Chief Technology Officer",
        "selectEmailDomain": "Select an email domain",
        "selectEmailDomainFirst": "Select an email domain first",
        "enterFirstName": "Enter first name",
        "enterLastName": "Enter last name"
      },
      "validation": {
        "companyNameRequired": "$t(clientAccess:validation.companyNameRequired)",
        "companyWebsiteRequired": "$t(clientAccess:validation.companyWebsiteRequired)",
        "validUrlRequired": "$t(clientAccess:validation.validUrlRequired)",
        "companySizeRequired": "$t(clientAccess:validation.companySizeRequired)",
        "countryRequired": "$t(clientAccess:validation.countryRequired)",
        "validEmailRequired": "Please enter a valid email",
        "emailDomainRequired": "Please select an email domain",
        "emailMustMatchDomain": "Email must end with @{{domain}}",
        "productsRequired": "Please select at least one product your organisation uses"
      },
      "labels": {
        "emailDomain": "Email Domain"
      },
      "buttons": {
        "cancel": "$t(common:components.buttons.cancel)",
        "nextIdentityProvider": "Next: Identity Provider"
      }
    }
  },
  "referenceData": {
    "labels": {
      "isoCode": "Currency ISO Code",
      "searchByCurrencyNameOrCode": "Search by currency name or code",
      "providerId": "Provider",
      "currencyVersion": "Currency Version",
      "deactivatedAt": "Deactivated At",
      "deprecatedAt": "Deprecated At",
      "currencyDetails": "Currency Details"
    },
    "components": {
      "currencyDetails": {
        "deleteCurrency": "Delete Currency",
        "updatedSuccess": "Currency Update Success"
      }
    },
    "errors": {
      "updateFailed": "Currency Update Failed",
      "invalidFields": "Invalid Fields",
      "invalidIsoCode": "Invalid ISO Code"
    },
    "validation": {
      "currencyNameRequired": "Please enter a currency name",
      "currencyNameMinimLength": "Currency name must be at least 3 characters",
      "currencyISOCodeRequired": "Please enter a currency ISO code"
    }
  }
}
